import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { WhatComponent } from './components/what/what.component';
import { TreatmentComponent } from './components/treatment/treatment.component';
import { QuestionnaireComponent } from './components/questionnaire/questionnaire.component';
import { ReferralComponent } from './components/referral/referral.component';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NavigationComponent } from './components/navigation/navigation.component';
import { IntroductionComponent } from './components/introduction/introduction.component';



@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    WhatComponent,
    TreatmentComponent,
    QuestionnaireComponent,
    ReferralComponent,
    NavigationComponent,
    IntroductionComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
